<template>
    <q-dialog v-model="toggleExportFieldModal" persistent>
        <q-card class="export-field-component">
            <q-card-section>
                <div class="text-h6">
                    <div class="header-form">
                        <div>Seleccionar Campos a Exportar</div>
                        <q-btn color="negative" icon="close" v-close-popup>
                            <q-tooltip>Cerrar ventana</q-tooltip>
                        </q-btn>
                    </div>
                </div>
            </q-card-section>

            <q-card-section>
                <table-component :loading="loading" :enablePagination="false" :enableMultipleSelection="true"
                    :selectedItems="selectedItems" @selected-items="updateSelectedItems" :tableStyle="TableStyle.SUBSERVICE" />
            </q-card-section>

            <q-card-actions align="center">
                <q-btn color="primary" label="Aceptar" @click="onAccept" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script lang="ts">
import ExportFieldComponent from './ExportFieldComponent';
export default ExportFieldComponent;
</script>

<style lang="scss" src="./ExportFieldComponent.scss"></style>